const FireAuth = require("util/FireAuth");
const Sanitizer = require("util/Sanitizer");
const Loader = require("util/Loader");
const Dater = require("util/Dater");
const Formatter = require("util/Formatter");
const StringTools = require("util/StringTools");

const FB = {
    onResolve : function(cb, cbData){
        return function(data){
            if(cb)
                cb(data, cbData);
        }
    },
    onReject : function(cb){
        return function(data){
            if(cb)
                cb(data);
        }
    },
    invoke : function(cb){
        if(FB.busy)
            return;
        FB.busy = true;
        Loader.script("/vendor/firebase.js", "firebase", function(){
            FB.init();
            FB.busy = false;
            cb();
        });
    },

    init(){
        if(!firebase)
            return;
        var config = {
            apiKey: "AIzaSyDYH5EU52_z-SR1pjQe2MEdE_OUUXapKdw",
            authDomain: "iexpenseonline.firebaseapp.com",
            databaseURL: "https://iexpenseonline.firebaseio.com",
            projectId: "iexpenseonline",
            storageBucket: "gs://iexpenseonline.appspot.com",
            messagingSenderId: "769386440496"
        };
        firebase.initializeApp(config);
        FireAuth.init();
        FB.initialized = true;
    },

    //-------PROTECTED
    readProtectedData(destination, cb){
        firebase.database().ref('/protected/' + destination + "/").once('value').then(FB.onResolve(cb), FB.onReject(cb));
    },

    writeProtectedData(destination, data, cb){
        Sanitizer.invoke(data);
        data.updated_on = firebase.database.ServerValue.TIMESTAMP;
        if(data.id){ // UPDATE
            let _id = data.id;
            delete data.id;
            firebase.database().ref('/protected/' + destination + '/' + _id + "/").set(data).then(FB.onResolve(cb), FB.onReject(cb));
        }
        else{//ADD
            delete data.id; // in case its declared but undefined.
            firebase.database().ref('/protected/' + destination + '/').push(data).then(FB.onResolve(cb), FB.onReject(cb));
        }
    },

    log(dest, data, cb){
        let user = FireAuth.authenticatedUser();
        let ownerStr = "anonymous";
        Sanitizer.invoke(data);
        if(user && user.uid){
            data.user_id = user.uid;
            ownerStr = user.email.replace(/\./g, "_");
            ownerStr = ownerStr.replace(new RegExp("#|$|[|]", 'g'), "_");
        }
        else if(data){
            ownerStr = data.platform + " " + data.screen;
        }
        data.date = new Date().toString();
        data.updated_on = firebase.database.ServerValue.TIMESTAMP;
        firebase.database().ref('/logs/' + ownerStr + '/' + dest).push(data).then(FB.onResolve(cb), FB.onReject(cb));
    },

    deleteProtectedData(destination, uid, cb){
        let path = '/protected/' + destination + '/' + uid + '/';
        firebase.database().ref(path).remove().then(FB.onResolve(cb), FB.onReject(cb));
    },

    uploadProtectedFile($fileInput, destination, cb){
        let file = $fileInput[0].files[0];
        let storageRef = firebase.storage().ref();
        let filePath = "/protected/" + destination + "/" + file.name;
        let fileStorageRef = storageRef.child(filePath);
        fileStorageRef.put(file).then(FB.onResolve(cb), FB.onReject(cb));
    },

    //-------PRIVATE
    readPrivateData(destination, cb){
        let userId = firebase.auth().currentUser.uid;
        firebase.database().ref('/private/' + userId + "/" + destination).once('value').then(FB.onResolve(cb), FB.onReject(cb));
    },

    writePrivateData(destination, data, cb){
        let userId = firebase.auth().currentUser.uid;
        Sanitizer.invoke(data);
        data.updated_on = firebase.database.ServerValue.TIMESTAMP;
        if(data.id){ // UPDATE
            let _id = data.id;
            delete data.id;
            firebase.database().ref('/private/' + userId + "/" + destination + '/' + _id + "/").set(data).then(FB.onResolve(cb), FB.onReject(cb));
        }
        else{//ADD
            delete data.id; // in case its declared but undefined.
            firebase.database().ref('/private/' + userId + '/' + destination).push(data).then(FB.onResolve(cb), FB.onReject(cb));
        }
    },

    deletePrivateData(destination, uid, cb){
        let userId = firebase.auth().currentUser.uid;
        if(uid){
            let path = '/private/' + userId + "/" + destination + '/' + uid;
            firebase.database().ref(path).remove().then(FB.onResolve(cb), FB.onReject(cb));
        }
    },

    deleteUserData(cb){
        let userId = firebase.auth().currentUser.uid;
        let path = '/private/' + userId;
        firebase.database().ref(path).remove().then(FB.onResolve(cb), FB.onReject(cb));
    },

    uploadPrivateFile($fileInput, destination, cb){
        let file = $fileInput[0].files[0];
        let storageRef = firebase.storage().ref();
        let userId = firebase.auth().currentUser.uid;
        let todayStr = Formatter.singleDate(Dater.getNewDate(new Date(), 0));
        let filePath = "/private/" + userId + "/" + destination + "/" + todayStr + "/" + file.name;
        let fileStorageRef = storageRef.child(filePath);
        fileStorageRef.put(file).then(FB.onResolve(cb), FB.onReject(cb));
    },

    deletePrivateFile(filePath, cb, cbData){
        let storageRef = firebase.storage().ref();
        let userStorageRef = storageRef.child(filePath);
        userStorageRef.delete().then(FB.onResolve(cb, cbData), FB.onReject(cb));
    },

    // GENERIC:
    downloadFile(filePath, cb, cbData){
        let storageRef = firebase.storage().ref();
        let userStorageRef = storageRef.child(filePath);
        userStorageRef.getDownloadURL().then(FB.onResolve(cb, cbData), FB.onReject(cb));
    },

    updateProfile(data, cb){
        let user = firebase.auth().currentUser;
        if(user){
            user.updateProfile(data).then(function(){
                cb(true);
                FireAuth.profileUpdated();
            }, FB.onReject(cb));
        }
    },

    //STUFF FROM OTHER PROJECTS, REMOVE IF NOT USED:

    //-------PRIVATE
    readUserData(destination, cb){
        let userId = firebase.auth().currentUser.uid;
        firebase.database().ref('/private/' + destination + "/" + userId).once('value').then(FB.onResolve(cb), FB.onReject(cb));
    },

    writeUserData(destination, data, cb){
        let userId = firebase.auth().currentUser.uid;
        Sanitizer.invoke(data);
        firebase.database().ref('/private/' + destination + '/' + userId).set(data).then(FB.onResolve(cb), FB.onReject(cb));
    },


    //-------PUBLIC
    writePublicData(destination, data, cb){
        firebase.database().ref('/public/' + destination + '/').push(data).then(FB.onResolve(cb), FB.onReject(cb));
    },

    uploadPublicFile($input, destination, cb){
        let file = $input[0].files[0];
        let storageRef = firebase.storage().ref();
        let filePath = "/public/" + destination + "/" + file.name;
        let fileStorageRef = storageRef.child(filePath);
        fileStorageRef.put(file).then(function(snapshot){
            cb($input, snapshot);
        }, FB.onReject(cb));
    },

    deleteFile(filePath, cb, cbData){
        let storageRef = firebase.storage().ref();
        let userStorageRef = storageRef.child(filePath);
        userStorageRef.delete().then(FB.onResolve(cb, cbData), FB.onReject(cb));
    },
}

module.exports = FB;


// WEBPACK FOOTER //
// ./src/control/util/FireBase.js